import { useEffect, useMemo, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../../../Network/API"

export default function CourseQuiz(props) {
    const navigate = useNavigate()
    const [mark_loading, setMarkLoading] = useState(false);
    // https://www.codevertiser.com/quiz-app-using-reactjs/
    const [q_ans, setQAns] = useState(0)
    const [activeQuestion, setActiveQuestion] = useState(0)
    const [selectedAnswer, setSelectedAnswer] = useState('')
    const [showResult, setShowResult] = useState(false)
    const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(null)

    let { idd } = useParams();
  
    const [result, setResult] = useState({
        score: 0,
        correctAnswers: 0,
        wrongAnswers: 0,
        skippedAnswers: 0,
    })
    // Seconds remaining on the current question's countdown timer.
    const [timeLeft, setTimeLeft] = useState(0)
    // Shuffle the quiz questions once when the data arrives so each attempt
    // presents them in a random order (kept stable across re-renders).
    const quiz = useMemo(() => {
        const items = [...(props?.quizes ?? [])]
        for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]]
        }
        return items
    }, [props?.quizes])

    const { id, title, questions, answare, duration } = quiz[activeQuestion]

    // Advance to the next question. When `skipped` is true the student ran out
    // of time (or didn't answer) so it counts as skipped rather than wrong.
    const goToNext = (skipped = false) => {
        setSelectedAnswerIndex(null)
        setResult((prev) =>
            skipped
                ? { ...prev, skippedAnswers: prev.skippedAnswers + 1 }
                : selectedAnswer
                    ? {
                        ...prev,
                        score: prev.score + 5,
                        correctAnswers: prev.correctAnswers + 1,
                    }
                    : { ...prev, wrongAnswers: prev.wrongAnswers + 1 }
        )
        markQuiz(id, skipped ? '' : q_ans)
        setSelectedAnswer('')
        setQAns(0)
        if (activeQuestion !== quiz.length - 1) {
            setActiveQuestion((prev) => prev + 1)
        } else {
            setActiveQuestion(0)
            setShowResult(true)
        }
        if (inputRef.current) inputRef.current.value = "";
    }

    const onClickNext = () => goToNext(false)

    // Stable reference so the countdown timer can advance without capturing
    // stale question state from the moment the interval was created.
    const goToNextRef = useRef(goToNext)
    goToNextRef.current = goToNext

    const onAnswerSelected = (correctAnswer, index) => {
        if(correctAnswer==""){
            setSelectedAnswerIndex(null)
            return;
        }
        setSelectedAnswerIndex(index)
        setQAns(correctAnswer)
        if (correctAnswer === answare) {
            setSelectedAnswer(true)
        } else {
            setSelectedAnswer(false)
        }

    }
    const inputRef = useRef(null);
    const addLeadingZero = (number) => (number > 9 ? number : `${number}`)
    const formatTime = (totalSeconds) =>
        `${addLeadingZero(Math.floor(totalSeconds / 60))}:${addLeadingZero(totalSeconds % 60)}`

    // Auto-focus the answer field whenever a new question is shown
    useEffect(() => {
        if (!showResult && inputRef.current) {
            inputRef.current.focus()
        }
    }, [activeQuestion, showResult])

    // Per-question countdown. The backend sets `duration` (in seconds) for each
    // question; when it elapses with no answer we auto-skip to the next one.
    const advancingRef = useRef(false)
    useEffect(() => {
        if (showResult) return
        advancingRef.current = false
        const seconds = Number(quiz[activeQuestion]?.duration) || 0
        setTimeLeft(seconds)
        if (seconds <= 0) return  // no time limit configured for this question

        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval)
                    if (!advancingRef.current) {
                        advancingRef.current = true
                        // Defer outside the state updater to avoid double-firing.
                        setTimeout(() => goToNextRef.current(true), 0)
                    }
                    return 0
                }
                return prev - 1
            })
        }, 1000)
        return () => clearInterval(interval)
    }, [activeQuestion, showResult])



    function markCourse() {
        setMarkLoading(true);
        API.get(`/mark_course_quiz_section?data=${props.data.uid}&is_complete=1&priority_index=0&watch_duration=0&score=${((result.correctAnswers/quiz.length)*100)}`)
            .then(response => {
                var datt = response.data.data;

                // Go to the next lecture/video (Course Content page) if one exists,
                // so students can continue to the next class right away.
                if (datt.uid != null) {
                    toast.success('Your lacture complete successfully');
                    if (datt.type == 0) {
                        navigate(`/lecture/${datt.uid}/${datt.slug}`)
                    } else if (datt.type == 1) {
                        navigate(`/course_quiz/${datt.uid}/${datt.slug}`)
                    }
                } else if (datt.course_complete == 1) {
                    // No further lectures — the whole course is finished.
                    toast.success('Your course complete successfully');
                    navigate(`/dashboard`)
                }
                setMarkLoading(false);
            }).catch((error) => {
                toast.error(error.response.data['message']);
            });
    }

    function markQuiz(qid, answer = q_ans) {
        API.get(`/mark_course_quiz?data=${qid}&answare=${answer}&question_index=${activeQuestion}`)
            .then(response => {
                if (response.data.data != "") {
                    
                }
            })
    }

    function retakQuiz() {
        setActiveQuestion(0)
        setShowResult(false)
        setResult({
            score: 0,
            correctAnswers: 0,
            wrongAnswers: 0,
            skippedAnswers: 0,
        })
    }

    return (
        <>
            <h6>{props.data.title}</h6>
            <div className="col-md-12">
                {!showResult ? (
                    <div className="quiz">
                        <section className="examTestProtalnumber mt-3 mb-3">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className=" me-2 m-0">Question Number:<strong className="orangeRed fs-16"> {addLeadingZero(activeQuestion + 1)}</strong></p>
                                            {Number(duration) > 0 && (
                                                <p className="me-2 m-0">Time Left:<strong className={`fs-16 ${timeLeft <= 5 ? 'text-danger' : 'orangeRed'}`}> {formatTime(timeLeft)}</strong></p>
                                            )}
                                            <p className="me-2 m-0">Total Question:<strong className="orangeRed fs-16">{addLeadingZero(quiz.length)}</strong></p></div>
                                        <div className="divided position-relative">
                                            <div className="divided-light-white" />
                                            <div className="divided-black" style={{ width: `${Number(duration) > 0 ? ((duration - timeLeft) / duration) * 100 : 0}%` }} /></div>
                                    </div></div></div></section>
                        <section className="examTestQuicks mb-3">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card bg-white shadow-lg py-2">
                                            <div className="card-body">
                                                <p style={{ fontSize: '1.15rem' }} className="mb-2">Q{addLeadingZero(Number(activeQuestion) + Number(1))}.{title}</p>
                                                <div className="d-flex flex-column align-items-center gap-2">
                                                    {questions.map((questionr, index1) => (
                                                        <h6 key={index1} className="mb-0 answer text-center" style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{questionr}</h6>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <form id="myForm">
                            <div className="container mb-4">
                                <div className="row">
                                    <div className="col-12">
                                        <h6 className="mt-2 mb-2" for={`mark${activeQuestion}`} style={{ fontSize: '1.15rem' }}>Answer</h6>
                                        <div className="card bg-white shadow-lg border-0">
                                            <input ref={inputRef} id={`mark${activeQuestion}`} name={`mark${activeQuestion}`} onChange={(e) => onAnswerSelected(e.target.value, answare)} className="form-control form-control-lg shadow-lg" type="text" aria-label="default input example" style={{ fontSize: '1.75rem', height: '70px' }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <section className="examTestAns mb-3">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="d-flex justify-content-between">
                                                <button type="button" className="btn btn-outline-dark"><i className="fas fa-arrow-left me-1" /> Go Back</button>
                                                <button type="submit" className="btn orangeRed-bg text-white" onClick={onClickNext}
                                                    disabled={selectedAnswerIndex === null}> {activeQuestion === quiz.length - 1 ? 'Finish' : 'Next'} <i className="fas fa-arrow-right ms-1" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </form>
                    </div>
                ) : (
                    <div className="result">
                        <h3>Result</h3>
                        <p>
                            Total Question: <span>{quiz.length}</span>
                        </p>
                        <p>
                            Total Score:<span> {result.score}</span>
                        </p>
                        <p>
                            Correct Answers:<span> {result.correctAnswers}</span>
                        </p>
                        <p>
                            Wrong Answers:<span> {result.wrongAnswers}</span>
                        </p>
                        <p>
                            Skipped / Not Answered:<span> {result.skippedAnswers}</span>
                        </p>
                        <div className="text-center">
                            <button onClick={() => retakQuiz()} className="btn btn-outline-info mb-2 "><i className="fas fa-arrow-left"></i> Retake Quiz</button> <span style={{ width: '10px' }}></span> <button onClick={() => markCourse()} className="btn btn-outline-warning mb-2">Complete & Continue <i className="fas fa-arrow-right"></i></button>

                        </div>
                    </div>
                )}

            </div>

        </>
    )
}